import { useAuth } from "../../auth/AuthContext";
import { TabbedPage } from "../../components/TabbedPage";
import { StaffPage } from "../staff/StaffPage";
import { BranchesPage } from "../branches/BranchesPage";
import { PermissionsPage } from "../permissions/PermissionsPage";
import { ROLES_WITH_BRANCH_ACCESS, ROLES_WITH_PERMISSIONS_ACCESS, ROLES_WITH_STAFF_ACCESS } from "../../roles/permissions";

/** Merged Staff + Branches + Permissions. Staff is visible to OWNER/BRANCH_MANAGER;
 * Branches and Permissions are OWNER-only — this page filters its own tab list by role
 * rather than relying solely on the route-level guard (which must stay as broad as
 * ROLES_WITH_STAFF_ACCESS to admit BRANCH_MANAGER at all). The "Staff" tab renders the
 * exact same `StaffPage` component the basic nav's own "Staff" item links to directly —
 * one implementation, reached two ways. */
export function TeamPage() {
  const { user } = useAuth();
  const role = user?.role;
  const showStaff = role ? ROLES_WITH_STAFF_ACCESS.includes(role) : false;
  const showBranches = role ? ROLES_WITH_BRANCH_ACCESS.includes(role) : false;
  const showPermissions = role ? ROLES_WITH_PERMISSIONS_ACCESS.includes(role) : false;

  return (
    <TabbedPage
      title="Team"
      defaultTab={showStaff ? "staff" : showBranches ? "branches" : "permissions"}
      tabs={[
        ...(showStaff ? [{ key: "staff", label: "Staff", content: <StaffPage /> }] : []),
        ...(showBranches ? [{ key: "branches", label: "Branches", content: <BranchesPage /> }] : []),
        ...(showPermissions ? [{ key: "permissions", label: "Permissions", content: <PermissionsPage /> }] : []),
      ]}
    />
  );
}
